/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Top_ProductsInputs */

const vi_dashboard_manager_top_products = /** @type {(inputs: Dashboard_Manager_Top_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top 5 sản phẩm`)
};

/**

* @param {Dashboard_Manager_Top_ProductsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_top_products = /** @type {((inputs?: Dashboard_Manager_Top_ProductsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Top_ProductsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_top_products(inputs)
});